import { render, staticRenderFns } from "./aulas.vue?vue&type=template&id=36af42e2&"
import script from "./aulas.vue?vue&type=script&lang=js&"
export * from "./aulas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports